import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CrownIcon } from 'lucide-react';
import { brand, heroImage, heroQuote, heroQuoteIntro, heroSubtitle, heroTrust } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-night-950 pb-16 pt-10 md:pb-24 md:pt-14" data-id="element-86" data-mp="4lywsqa2emfr">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-87" data-mp="4jvxffn0vgyd">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2.5 font-display text-sm font-bold uppercase tracking-[0.24em] text-gold-400 md:text-base" data-id="element-88" data-mp="128phdbcgkt3i">
          <CrownIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-89" data-mp="nbyhz22sbhdw" />
          {brand}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-7 max-w-4xl font-display text-[2.5rem] font-bold leading-[1.08] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-90" data-mp="3cz5uuafyvxzt">
          Después de esto, ves el juego{' '}
          <span className="text-gold-300" data-id="element-91" data-mp="399jnddjryf64">que otros no ven.</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.12,
        ease
      }} src={heroImage} alt="El Código de Autoridad: portada premium, láminas de las 48 leyes ilustradas y los 5 bonos incluidos" className="mx-auto mt-11 w-full max-w-2xl" width={1240} height={1240} data-id="element-92" data-mp="3e8ehhbn6zq5j" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.18,
        ease
      }} className="mx-auto mt-12 max-w-2xl" data-id="element-93" data-mp="2vj7tpa7jk8cv">
          <p className="text-sm font-medium uppercase tracking-[0.18em] text-faint" data-id="element-94" data-mp="2lmlasqyrzrdh">
            {heroQuoteIntro}
          </p>
          <blockquote className="mt-4 border-l-2 border-gold-400/60 pl-5 text-left font-display text-xl font-semibold italic leading-snug text-ink md:text-2xl" data-id="element-95" data-mp="nat8heoiaqma">
            “{heroQuote}”
          </blockquote>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-96" data-mp="ddwwv03b9odi">{heroSubtitle}</p>
        </motion.div>

        <motion.ul initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.24,
        ease
      }} className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm font-medium text-muted" data-id="element-97" data-mp="1b15lh3ylzdjq">
          {heroTrust.map(item => <li key={item} className="inline-flex items-center gap-2" data-id="element-98" data-mp="x0uwk6gv0917">
              <CheckIcon className="h-4 w-4 text-indigo-400" strokeWidth={1.75} aria-hidden="true" data-id="element-99" data-mp="3lu03r3mln90s" />
              {item}
            </li>)}
        </motion.ul>
      </div>
    </section>;
}